
.c-popover {
  max-width: 600px;
  overflow: initial;
}

  .c-popover__title {
  padding: 0.5rem;
  border-top-left-radius: 0.5rem;
  border-top-right-radius: 0.5rem;
  --tw-bg-opacity: 1;
  background-color: rgb(244 244 245 / var(--tw-bg-opacity, 1));
  border-bottom-width: 1px;
  --tw-border-opacity: 1;
  border-color: rgb(212 212 216 / var(--tw-border-opacity, 1));
  text-align: center;
  font-size: 0.75rem;
  line-height: 1rem;
  font-weight: 600;
  --tw-text-opacity: 1;
  color: rgb(82 82 91 / var(--tw-text-opacity, 1));
}

  .c-popover__content {
  overflow: hidden;

    min-width: 150px;
}

  .c-popover__loading {
  padding: 0.5rem;
  text-align: center;

    min-width: 150px;
}

  @media (max-width: 767px) {

  .c-popover {
    top: unset !important;
    left: 0px !important;
    right: 0px !important;
    bottom: 0px !important;
    margin: 0px !important;
    position: fixed !important;
    transform: none !important;
    border-width: 0px;
    border-top-width: 2px;
    border-radius: 0px;
  }

  .c-popover[data-placement="top"],
  .c-popover[data-placement="bottom"] {
    top: unset !important;
  }

  .c-popover[data-placement="left"],
  .c-popover[data-placement="right"] {
    left: 0px !important;
  }

  .c-popover [data-arrow] {
    display: none !important;
  }

  .c-popover .c-button {
    width: 100%;
    max-width: 24rem;
  }
}

/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uL3Bpc3RhY2hpby9hcHAvY29tcG9uZW50cy9waXN0YWNoaW8vcG9wb3ZlcnNfY29tcG9uZW50LmNzcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiO0FBQ0E7RUFDRSxnQkFBZ0I7RUFDaEIsaUJBQWlCO0FBbURuQjs7RUFoREk7RUFBQSxlQUFVO0VBQ1YsOEJBQStCO0VBQS9CLCtCQUErQjtFQUEvQixrQkFBK0I7RUFBL0IsNERBQStCO0VBQy9CLHdCQUErQjtFQUEvQixzQkFBK0I7RUFBL0IsNERBQStCO0VBQy9CLGtCQUFzRDtFQUF0RCxrQkFBc0Q7RUFBdEQsaUJBQXNEO0VBQXRELGdCQUFzRDtFQUF0RCxvQkFBc0Q7RUFBdEQ7QUFIVTs7RUFPVjtFQUFBLGdCQUFzQjs7SUFFdEI7QUFGc0I7O0VBTXRCO0VBQUEsZUFBVTtFQUNWLGtCQUFrQjs7SUFFbEI7QUFIVTs7RUFPWjs7RUFBQTtJQUFBLHFCQUE4QjtJQUM5QixvQkFBMkI7SUFDM0IscUJBQTRCO0lBQzVCLHNCQUE2QjtJQUM3QixzQkFBd0I7SUFDeEIsMEJBQTBCO0lBQzFCLDBCQUFtQztJQUNuQyxpQkFBZ0M7SUFBaEMscUJBQWdDO0lBQ2hDO0VBUjhCOztFQWE1Qjs7SUFBQTtFQUE4Qjs7RUFLOUI7O0lBQUE7RUFBMkI7O0VBSTNCO0lBQUE7RUFBMkI7O0VBSTNCO0lBQUEsV0FBNEI7SUFBNUI7RUFBNEI7QUExQkEiLCJmaWxlIjoiLi4vcGlzdGFjaGlvL2FwcC9jb21wb25lbnRzL3Bpc3RhY2hpby9wb3BvdmVyc19jb21wb25lbnQuY3NzIiwic291cmNlc0NvbnRlbnQiOlsiXG4uYy1wb3BvdmVyIHtcbiAgbWF4LXdpZHRoOiA2MDBweDtcbiAgb3ZlcmZsb3c6IGluaXRpYWw7XG5cbiAgJl9fdGl0bGUge1xuICAgIEBhcHBseSBwLTI7XG4gICAgQGFwcGx5IGJnLWdyYXktMTAwIHJvdW5kZWQtdC1sZztcbiAgICBAYXBwbHkgYm9yZGVyLWIgYm9yZGVyLWdyYXktMzAwO1xuICAgIEBhcHBseSB0ZXh0LWdyYXktNjAwIHRleHQteHMgZm9udC1zZW1pYm9sZCB0ZXh0LWNlbnRlcjtcbiAgfVxuXG4gICZfX2NvbnRlbnQge1xuICAgIEBhcHBseSBvdmVyZmxvdy1oaWRkZW47XG5cbiAgICBtaW4td2lkdGg6IDE1MHB4O1xuICB9XG5cbiAgJl9fbG9hZGluZyB7XG4gICAgQGFwcGx5IHAtMjtcbiAgICBAYXBwbHkgdGV4dC1jZW50ZXI7XG5cbiAgICBtaW4td2lkdGg6IDE1MHB4O1xuICB9XG5cblxuICBAYXBwbHkgc206dG9wLXVuc2V0ICFpbXBvcnRhbnQ7XG4gIEBhcHBseSBzbTpsZWZ0LTAgIWltcG9ydGFudDtcbiAgQGFwcGx5IHNtOnJpZ2h0LTAgIWltcG9ydGFudDtcbiAgQGFwcGx5IHNtOmJvdHRvbS0wICFpbXBvcnRhbnQ7XG4gIEBhcHBseSBzbTptLTAgIWltcG9ydGFudDtcbiAgQGFwcGx5IHNtOmZpeGVkICFpbXBvcnRhbnQ7XG4gIEBhcHBseSBzbTp0cmFuc2Zvcm0tbm9uZSAhaW1wb3J0YW50O1xuICBAYXBwbHkgc206Ym9yZGVyLTAgc206Ym9yZGVyLXQtMjtcbiAgQGFwcGx5IHNtOnJvdW5kZWQtbm9uZTtcblxuXG4gICZbZGF0YS1wbGFjZW1lbnQ9XCJ0b3BcIl0sXG4gICZbZGF0YS1wbGFjZW1lbnQ9XCJib3R0b21cIl0ge1xuICAgIEBhcHBseSBzbTp0b3AtdW5zZXQgIWltcG9ydGFudDtcbiAgfVxuXG4gICZbZGF0YS1wbGFjZW1lbnQ9XCJsZWZ0XCJdLFxuICAmW2RhdGEtcGxhY2VtZW50PVwicmlnaHRcIl0ge1xuICAgIEBhcHBseSBzbTpsZWZ0LTAgIWltcG9ydGFudDtcbiAgfVxuXG4gIFtkYXRhLWFycm93XSB7XG4gICAgQGFwcGx5IHNtOmhpZGRlbiAhaW1wb3J0YW50O1xuICB9XG5cbiAgLmMtYnV0dG9uIHtcbiAgICBAYXBwbHkgc206dy1mdWxsIHNtOm1heC13LXNtO1xuICB9XG59XG4iXX0= */